'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var FormItem = _next.Form.Item;

var DataShareSearchForm = function (_Component) {
  _inherits(DataShareSearchForm, _Component);

  function DataShareSearchForm(props) {
    _classCallCheck(this, DataShareSearchForm);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleFormChange = function (values) {
      _this.setState({ formData: values });
    };

    _this.handleReset = function () {
      _this.setState({ formData: {} });
    };

    _this.getData = function () {
      var dataShareSearchFields = _this.props.dataShareSearchFields;
      var formData = _this.state.formData;

      var result = void 0;
      if ((0, _lodash.isEmpty)(formData) || (0, _lodash.isEmpty)(dataShareSearchFields)) {
        result = [];
      } else {
        result = dataShareSearchFields.map(function (field) {
          return (0, _lodash.isNil)(formData[field.label]) ? '' : formData[field.label];
        });
      }
      return {
        value: JSON.stringify(result)
      };
    };

    _this.state = { formData: {} };
    return _this;
  }

  DataShareSearchForm.prototype.componentDidMount = function componentDidMount() {
    var initCallback = this.props.initCallback;

    initCallback && initCallback(this);
  };

  DataShareSearchForm.prototype.render = function render() {
    var _props = this.props,
        dataShareSearchFields = _props.dataShareSearchFields,
        searchHandler = _props.searchHandler;


    if ((0, _lodash.isEmpty)(dataShareSearchFields)) {
      return null;
    }

    return _react2.default.createElement(
      _next.Form,
      { inline: true, className: 'vc-big-table-search-form', onChange: this.handleFormChange },
      dataShareSearchFields.map(function (item) {
        return _react2.default.createElement(
          FormItem,
          { label: item.label, className: 'vc-big-table-search-form-item' },
          _react2.default.createElement(_next.Input, { name: item.label })
        );
      }),
      _react2.default.createElement(
        'div',
        { className: 'vc-big-table-search-form-btn' },
        _react2.default.createElement(
          _next.Button,
          {
            style: { width: '75px' },
            type: 'secondary',
            onClick: function onClick() {
              searchHandler();
            }
          },
          '\u641C\u7D22'
        ),
        _react2.default.createElement(
          _next.Form.Reset,
          { style: { width: '75px', marginLeft: '20px' }, type: 'normal', onClick: this.handleReset },
          '\u91CD\u7F6E'
        )
      )
    );
  };

  return DataShareSearchForm;
}(_react.Component);

exports.default = DataShareSearchForm;
module.exports = exports['default'];